<section class="membership-placeholder">
  <header class="page-header">
    <h2 class="title">Members</h2>
  </header>
  <p class="lead">
    
  </p>
</section>
